import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-save-link-data',
    templateUrl: './save-link-data.component.html',
    styleUrls: ['./save-link-data.component.css'],
    standalone: false
})
export class SaveLinkDataComponent {

  constructor(
    public matDialog: MatDialogRef<SaveLinkDataComponent>,
    public nav: NavBarComponent,
  ) {
  }
  
    cancel(): void {
      this.matDialog.close({"option": "cancel"});
    }
  
    save(): void {
      this.matDialog.close({"option": "save"});
      this.nav.toggleLoading(true);
    }
  }
